/// Menu
// import Metismenu from "metismenujs";
import React, { useReducer, useContext, useEffect, useState, useMemo } from "react";
/// Scroll
import { Collapse } from 'react-bootstrap';
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { navtoggle } from "../../../store/actions/AuthActions";
import { MenuList, filterMenuByPermissions } from './Menu';
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { useTranslation } from "react-i18next";
import logo from "../../../images/ensss_logo.png";


const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
}

const SideBar = () => {
  const { t } = useTranslation();
  const menuLabel = (d) => (d.titleKey ? t(d.titleKey) : d.title);
  //  let d = new Date();
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
    ChangeIconSidebar,
    windowWidth,
  } = useContext(ThemeContext);

  // Mobile / tablette (< 1024px, style "overlay", cf. ThemeContext) : la barre
  // ouverte recouvre le header et donc le bouton hamburger -> on doit pouvoir
  // la fermer depuis la barre elle-même, en cliquant à côté, ou en choisissant
  // une page.
  const dispatch = useDispatch();
  const location = useLocation();
  const sideMenu = useSelector((state) => state.sideMenu);
  const isMobile = windowWidth > 0 && windowWidth < 1024;
  const closeMobileMenu = () => {
    if (isMobile && sideMenu) dispatch(navtoggle());
  };

  useEffect(() => {
    closeMobileMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const [state, setState] = useReducer(reducer, initialState);

  const userPermissions = useSelector(
    (state) => state.auth.auth?.user?.permissions
  ) || [];

  const userRoles = useSelector(
    (state) => state.auth.auth?.user?.roles
  ) || [];


  const filteredMenuList = useMemo(
    () =>
      filterMenuByPermissions(
        MenuList,
        userPermissions,
        userRoles
      ),
    [
      JSON.stringify(userPermissions),
      JSON.stringify(userRoles)
    ]
  );

  let handleheartBlast = document.querySelector('.heart');
  function heartBlast() {
    return handleheartBlast.classList.toggle("heart-blast");
  }

  const [hideOnScroll, setHideOnScroll] = useState(true)
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y
      if (isShow !== hideOnScroll) setHideOnScroll(isShow)
    },
    [hideOnScroll]
  )


  const handleMenuActive = status => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  }
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status })
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" })
    }
  }
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  /// Active menu


  useEffect(() => {
    filteredMenuList.forEach((data) => {
      data.content?.forEach((item) => {
        if (path === item.to) {
          setState({ active: data.title })
        }
        item.content?.forEach(ele => {
          if (path === ele.to) {
            setState({ activeSubmenu: item.title, active: data.title })
          }
        })
      })
    })
  }, [path, filteredMenuList]);

  return (
    <>
    {isMobile && sideMenu && (
      <div className="sidebar-backdrop" onClick={closeMobileMenu} aria-hidden="true" />
    )}
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`dlabnav ${iconHover} ${sidebarposition.value === "fixed" &&
          sidebarLayout.value === "horizontal" &&
          headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
        }`}
    >
      <div className="sidebar-brand tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-4">
      <Link to="/dashboard" className="tw-flex tw-items-center tw-gap-2 tw-no-underline">
        <img
          src={logo}
          alt="ENSSS QCM Logo"
          className="tw-w-12 tw-h-12 tw-object-contain tw-shrink-0"
          width="48"
          height="48"
        />
        <h1 className="sidebar-brand-title tw-m-0 tw-text-[15px] tw-font-bold tw-tracking-wide tw-leading-tight">
          ENSSS QCM
        </h1>
      </Link>
        {isMobile && (
          <button
            type="button"
            aria-label="Fermer le menu"
            onClick={closeMobileMenu}
            className="tw-ms-auto tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-rounded-md tw-bg-transparent tw-border-0 tw-text-[#303972] dark:tw-text-white"
          >
            <i className="ti ti-x fs-20"></i>
          </button>
        )}
      </div>
      <div className="dlabnav-scroll">
        <ul className="metismenu" id="menu">
          {filteredMenuList.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index} >{menuLabel(data)}</li>
              )
            } else {
              return (
                <li className={`${state.active === data.title ? 'mm-active' : ''} `} key={index} >
                  {data.content && data.content.length > 0 ?
                    <>
                      <Link to={"#"}
                        className="has-arrow"
                        onClick={() => { handleMenuActive(data.title) }}
                      >
                        {data.iconStyle}
                        <span className="nav-text">{menuLabel(data)}</span>
                        <span className="ms-1 badge badge-xs style-1 badge-danger">{data.update}</span>
                      </Link>
                      <Collapse in={state.active === data.title ? true : false}>
                        <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                          {data.content && data.content.map((data, index) => {
                            return (
                              <li key={index}
                                className={`${state.activeSubmenu === data.title ? "mm-active" : ""}`}
                              >
                                {data.content && data.content.length > 0 ?
                                  <>
                                    <Link to={data.to} className={data.hasMenu ? 'has-arrow' : ''}
                                      onClick={() => { handleSubmenuActive(data.title) }}
                                    >
                                      {menuLabel(data)}
                                    </Link>
                                    <Collapse in={state.activeSubmenu === data.title ? true : false}>
                                      <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                                        {data.content && data.content.map((data, index) => {
                                          return (

                                            <li key={index}>
                                              <Link className={`${path === data.to ? "mm-active" : ""}`} to={data.to}>{menuLabel(data)}</Link>
                                            </li>

                                          )
                                        })}
                                      </ul>
                                    </Collapse>
                                  </>
                                  :
                                  <Link to={data.to} className={`${data.to === path ? 'mm-active' : ''}`} >
                                    {menuLabel(data)}
                                  </Link>
                                }
                              </li>
                            )
                          })}
                        </ul>
                      </Collapse>
                    </>
                    :
                    <Link to={data.to} className={`${data.to === path ? 'mm-active' : ''}`}>
                      {data.iconStyle}
                      <span className="nav-text">{menuLabel(data)}</span>
                    </Link>
                  }

                </li>
              )
            }
          })}
        </ul>

        {/* <div className="copyright">
              <p><strong>School Admission Dashboard</strong></p>
              <p className="fs-12">Made with <span className="heart" onClick={heartBlast}></span> by DexignLab</p>
            </div> */}
      </div>
    </div>
    </>
  );
};

export default SideBar;
